;(function () {
  const collectionHandle = 'hot-product-series'
  const gridSelector = '#facet-main .product-list__inner, .product-list__inner'
  const handlePattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/
  const requestTimeouts = [7000, 10000]

  function isHotCollectionPage() {
    const path = window.location.pathname.replace(/\/+$/, '')
    return path.includes('/collections/') && path.split('/').pop() === collectionHandle
  }

  function parsePriorityHandles() {
    const firstSegment = window.location.search.replace(/^\?/, '').split('&')[0]

    if (!firstSegment || firstSegment.includes('=')) return []

    const seen = new Set()

    return firstSegment
      .replace(/%2C/gi, ',')
      .split(',')
      .map(part => {
        try {
          return decodeURIComponent(part)
        } catch (error) {
          return part
        }
      })
      .map(handle => String(handle || '').trim().toLowerCase())
      .filter(handle => {
        if (!handlePattern.test(handle) || seen.has(handle)) return false
        seen.add(handle)
        return true
      })
      .slice(0, 20)
  }

  function markReady(facet) {
    document.documentElement.classList.remove('chicchok-hot-priority-pending')
    document.documentElement.classList.add('chicchok-hot-priority-ready')

    if (facet) facet.setAttribute('aria-busy', 'false')
  }

  function revealInsertedCards(grid) {
    grid.querySelectorAll('product-item[reveal], .product-item[reveal]').forEach(card => {
      card.removeAttribute('reveal')
      card.style.opacity = '1'
    })
  }

  function clearInlineImageState(wrapper) {
    wrapper.querySelectorAll('[data-chicchok-hot-priority-inline-image]').forEach(image => {
      image.style.opacity = ''
      image.style.visibility = ''
      image.removeAttribute('data-chicchok-hot-priority-inline-image')
    })
  }

  function repairHoverImage(wrapper) {
    const primary =
      wrapper.querySelector('.product-item__primary-image:not([hidden])') ||
      wrapper.querySelector('.product-item__primary-image')
    const secondary = wrapper.querySelector('.product-item__secondary-image')

    if (!primary || !secondary) return

    window.requestAnimationFrame(() => {
      if (!wrapper.matches(':hover')) return

      const secondaryStyle = window.getComputedStyle(secondary)
      if (
        secondaryStyle.visibility === 'visible' &&
        Number.parseFloat(secondaryStyle.opacity || '0') > 0.5
      ) {
        return
      }

      primary.setAttribute('data-chicchok-hot-priority-inline-image', 'true')
      secondary.setAttribute('data-chicchok-hot-priority-inline-image', 'true')
      primary.style.visibility = 'hidden'
      primary.style.opacity = '0'
      secondary.style.visibility = 'visible'
      secondary.style.opacity = '1'
    })
  }

  function bindPriorityCard(card) {
    if (card.dataset.chicchokHotPriorityBound === 'true') return

    const wrapper = card.querySelector('.product-item__image-wrapper')

    if (wrapper) {
      wrapper.addEventListener('pointerenter', () => repairHoverImage(wrapper))
      wrapper.addEventListener('pointerleave', () => clearInlineImageState(wrapper))
    }

    card.dataset.chicchokHotPriorityBound = 'true'
  }

  function initializePriorityCards(grid) {
    grid.querySelectorAll('[data-chicchok-hot-priority]').forEach(bindPriorityCard)
  }

  async function fetchPriorityMarkup(renderUrl) {
    let lastError = null

    for (let attempt = 0; attempt < requestTimeouts.length; attempt += 1) {
      const controller = new AbortController()
      const timeoutId = window.setTimeout(() => controller.abort(), requestTimeouts[attempt])

      try {
        const response = await fetch(renderUrl.href, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: controller.signal,
        })

        if (!response.ok) throw new Error(`Priority render failed: ${response.status}`)

        return await response.text()
      } catch (error) {
        lastError = error

        if (attempt < requestTimeouts.length - 1) {
          await new Promise(resolve => window.setTimeout(resolve, 250))
        }
      } finally {
        window.clearTimeout(timeoutId)
      }
    }

    throw lastError || new Error('Priority render failed')
  }

  async function hydratePriorityGrid() {
    if (!isHotCollectionPage()) return

    const handles = parsePriorityHandles()
    const facet = document.querySelector('product-facet')
    const currentGrid = document.querySelector(gridSelector)

    if (!handles.length || !facet || !currentGrid) {
      markReady(facet)
      return
    }

    const sectionId = facet.getAttribute('section-id')
    if (!sectionId) {
      markReady(facet)
      return
    }

    facet.setAttribute('aria-busy', 'true')

    try {
      const renderUrl = new URL(window.location.href)
      renderUrl.search = ''
      renderUrl.searchParams.set('section_id', sectionId)
      renderUrl.searchParams.set('sort_by', handles.join(','))

      const html = await fetchPriorityMarkup(renderUrl)
      const renderedDocument = new DOMParser().parseFromString(html, 'text/html')
      const renderedGrid = renderedDocument.querySelector(gridSelector)

      if (!renderedGrid?.hasAttribute('data-chicchok-hot-priority-grid')) {
        throw new Error('Priority render did not return the expected grid')
      }

      currentGrid.innerHTML = renderedGrid.innerHTML
      revealInsertedCards(currentGrid)
      initializePriorityCards(currentGrid)
    } catch (error) {
      console.warn('[CHICCHOK] Hot priority order was not applied after retry.', error)
    } finally {
      markReady(facet)
    }
  }

  hydratePriorityGrid()
})()
